import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './app/environments/environment.development';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  console.log("IsProduction Environment: ", environment.production)
 // enableProdMode();
 enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
